export default function (date) {
  if (!date) return

  let newDate = new Date(date)

  return newDate.toLocaleTimeString('uk-UA', { hour: '2-digit', minute: '2-digit' })
}